import type { KeyObjectType } from 'reducers/KeywordsAndPhrasesReducer/KeywordsAndPhrasesReducer.d'
import ExpandablePopover from './ExpandablePopover/ExpandablePopover'
import HighlightedPopoverSpan from './Highlighting/HighlightedPopoverSpan/HighlightedPopoverSpan'

const mockKeywordsData = {
  product: [
    {
      title: 'Mock Required keywords',
      type: 'keyword' as KeyObjectType,
      keys: [
        { key: 'Mock volume', currentCount: 10, originalCount: 8 },
        { key: 'Mock black', currentCount: 15, originalCount: 14 },
        { key: 'Mock brush', currentCount: 24, originalCount: 0 },
        { key: 'Mock mascara', currentCount: 15, originalCount: 0 },
        { key: 'Mock smudging', currentCount: 0, originalCount: 1 },
        { key: 'Mock test', currentCount: 0, originalCount: 0 },
      ],
    },
    {
      title: 'Mock Required keyphrases',
      type: 'keyphrases' as KeyObjectType,
      keys: [
        { key: 'Mock easily remove', currentCount: 10, originalCount: 8 },
        { key: 'Mock fan effect', currentCount: 15, originalCount: 14 },
        { key: 'Mock tested on sensitive eyes', currentCount: 24, originalCount: 0 },
        { key: 'Mock the low wax formula', currentCount: 15, originalCount: 0 },
        { key: 'Mock 6 different size bristles', currentCount: 0, originalCount: 1 },
        { key: 'Mock slightly twist', currentCount: 0, originalCount: 0 },
      ],
    },
  ],
  brand: [
    {
      title: 'Mock Required brand keywords',
      type: 'keyword' as KeyObjectType,
      keys: [
        { key: 'Mock brand volume', currentCount: 10, originalCount: 8 },
        { key: 'Mock brand brush', currentCount: 24, originalCount: 0 },
        { key: 'Mock brand mascara', currentCount: 15, originalCount: 0 },
        { key: 'Mock brand smudging', currentCount: 0, originalCount: 1 },
        { key: 'Mock brand test', currentCount: 0, originalCount: 0 },
      ],
    },
    {
      title: 'Mock Required brand keyphrases',
      type: 'keyphrases' as KeyObjectType,
      keys: [
        { key: 'Mock brand easily remove', currentCount: 10, originalCount: 8 },
        { key: 'Mock brand fan effect', currentCount: 15, originalCount: 14 },
        { key: 'Mock brand fan effect', currentCount: 0, originalCount: 14 },
        { key: 'Mock brand tested on sensitive eyes', currentCount: 24, originalCount: 0 },
        { key: 'Mock brand the low wax formula', currentCount: 15, originalCount: 0 },
        { key: 'Mock brand 6 different size bristles', currentCount: 0, originalCount: 1 },
        { key: 'Mock brand slightly twist', currentCount: 0, originalCount: 0 },
      ],
    },
  ],
  retailer: [
    {
      title: 'Mock Required retailer keywords',
      type: 'keyword' as KeyObjectType,
      keys: [{ key: 'Mock retailer volume', currentCount: 2, originalCount: 8 }],
    },
    {
      title: 'Mock Required retailer keyphrases',
      type: 'keyphrases' as KeyObjectType,
      keys: [
        { key: 'Mock retailer easily remove', currentCount: 10, originalCount: 8 },
        { key: 'Mock retailer fan effect', currentCount: 15, originalCount: 14 },
        { key: 'Mock retailer fan effect', currentCount: 0, originalCount: 14 },
        { key: 'Mock retailer tested on sensitive eyes', currentCount: 24, originalCount: 0 },
        { key: 'Mock retailer the low wax formula', currentCount: 15, originalCount: 0 },
        { key: 'Mock retailer 6 different size bristles', currentCount: 0, originalCount: 1 },
        { key: 'Mock retailer slightly twist', currentCount: 0, originalCount: 0 },
      ],
    },
  ],
}

export { ExpandablePopover, HighlightedPopoverSpan as Keyword, mockKeywordsData }
